import Add from "@mui/icons-material/Add";
import Check from "@mui/icons-material/Check";
import { Button, Stack } from "@mui/material";
import { useCart } from "@shopify/hydrogen-react";
import { Link } from "gatsby";
import React, { useEffect, useState } from "react";
import { useAnalytics } from "../../../../shared/analytics";

type AddToCartControlProps = {
    variantId: string;
    quantity: number;
    available: boolean;
    pageType: string
    product: Queries.ShopifyProductCardFragment
    withBuyNow?: boolean
    withShopPay?: boolean
    pathname: string
}

export function AddToCart({ variantId, quantity, available, pageType, product, withBuyNow, withShopPay, pathname }: AddToCartControlProps) {
    const { status, linesAdd, totalQuantity } = useCart();
    const loading = status === 'updating' || status === 'creating'

    const rootId = product.id + ''
    const btnId = rootId + '-btn'
    const buyNowId = rootId + '-buynow'
    const iconId = rootId + '-icon'

    const analytics = useAnalytics();

    const simple = !withBuyNow && !withShopPay;

    const [justAddedToCart, setJustAddedToCart] = useState(false);
    const [addedToCart, setAddedToCart] = useState(false);

    useEffect(() => {
        // console.log('heree status', status)
        if (loading && pathname !== '/cart' && pathname !== '/cart/') {
            setJustAddedToCart(true);
            setAddedToCart(true);
            setTimeout(() => {
                setJustAddedToCart(false)
            }, 4000)
        }
    }, [status])

    function addToCart(e) {
        e.preventDefault()
        linesAdd([
            { quantity, merchandiseId: variantId }
        ])

        analytics.trackAddToCart(
            [
                {
                    ...product
                }
            ]
            , variantId, quantity);
    }

    return (
        <Stack direction='row' justifyContent={'space-between'} alignItems={'center'} spacing={2}>
            <Button loading={loading}
                id={rootId}
                disabled={!available || loading}
                onClick={addToCart}
                // color={justAddedToCart ? 'success' : 'primary'}
                color={'primary'}
                startIcon={justAddedToCart ? <Check id={iconId} /> : <Add id={iconId} />}
                sx={[simple ? {
                    width: '100%'
                } : {
                    width: 'auto'
                }]}
                variant={simple ? 'contained' : 'contained'}>{available ? "Add to cart" : "Out of Stock"}</Button>
            {addedToCart || totalQuantity > 0 ? (
                <Button variant='contained' color='success' component={Link}
                    id={btnId} to='/cart'
                    sx={[simple ? {
                        width: '100%'
                    } : {
                        width: 'auto'
                    }]} startIcon={<Check />}>Checkout</Button>)
                : <></>}
            {/* {available && withBuyNow && <BuyNowButton as={Button} id={buyNowId} loading={loading}
                disabled={loading}
                variantId={variantId}
                variant='contained'>{"Buy now"}</BuyNowButton>} */}
            {/* {available && withShopPay && <ShopPayButton
                width='150px'
                storeDomain={process.env.GATSBY_SHOPIFY_CHECKOUT_DOMAIN}
                variantIds={[variantId]} />
            } */}
        </Stack>
    );
}
